import { render } from "./AccessLogView.vue?vue&type=template&id=1b1ec6f0"
import script from "./AccessLogView.vue?vue&type=script&lang=js"
export * from "./AccessLogView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__